import { PageContent } from './../../shared/classes/page-content.model';
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { DataService } from '../../shared/data.service';
import { RightSideService } from '../../shared/right-side.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Question } from '../../shared/classes/question.model';
import { Answer } from '../../shared/classes/answer.model';
import { Proposal } from '../../shared/classes/second-tab.model';
import { PriceResponse } from '../../shared/classes/price-response.model';
import { FormDataService } from '../../shared/form-data.service';
import * as _ from 'underscore';
import { Router } from '@angular/router';
import { NavigationBarService } from '../../shared/navigation-bar.service';
import { storageFactory, detectmob } from '../../../../app-storage';
import hbusApiClient from '../../../../analytics/hbusApiClient';
@Component({
  selector: 'app-second-tab',
  templateUrl: './second-tab.component.html',
  styleUrls: ['./second-tab.component.css'],
  host: {
    class: 'col-md-9 col-lg-9 col-sm-12 col-12'
  }
})
export class SecondTabComponent implements OnInit, AfterViewInit {
  tabSelected = 2;
  formMandatoryError: any;
  errorTexts: string[] = [];
  serviceErrors: string[] = [];
  charCount = 2000;
  questions: Question[] = [];
  defaultQuestions: Question[] = [];
  validLength = false;
  newAnswers: Answer[] = [];
  oldAnswers: Answer[] = [];
  productQuestionsForm: FormGroup = new FormGroup({});
  proposal: Proposal = new Proposal();
  initialized = false;
  isValid = true;
  serviceError = false;
  pageContent: PageContent;
  isIOS: boolean;
  cashbackSelected = false;
  isAuth: boolean;
  shopperId: string;
  cashbackEnabled = false;
  isShownIBAN = false;
  isAuthWarning = false;
  categoryName: string;
  brandName: string;
  modelName: string;

  constructor(
    private selecBoxService: DataService,
    private tabsService: RightSideService,
    private formDataService: FormDataService,
    private navBarService: NavigationBarService,
    private router: Router
  ) {
    this.cashbackEnabled = this.tabsService.getCashbackEnabled();
    this.pageContent = this.tabsService.getPageContent();
    this.categoryName = this.tabsService.getCategoryName();
    this.brandName = this.tabsService.getBrandName();
    this.modelName = this.tabsService.getModelName();
    this.formMandatoryError = this.pageContent.secondTabFillMandatoryFields;
    this.tabsService.pageContentChange.subscribe(() => {
      this.pageContent = this.tabsService.getPageContent();
    });
    this.cashbackSelected = this.tabsService.getCashbackSelected();
    this.isIOS = (storageFactory(localStorage).getItem('isIOS') === 'true');
    this.getQuestions(this.tabsService.selectedCategoryId);
    this.isAuth = this.tabsService.getIsAuth();
    this.shopperId = this.tabsService.getShopperId();
    this.isAuthWarning = this.tabsService.getIsAuthWarning();
  }

  ngOnInit() {
    this.productQuestionsForm = this.toFormGroup(this.questions);
    if (this.tabSelected !== 5) {
      const elmnt = document.getElementById('navHead');
      const isMobile = detectmob();
      if (isMobile) {
        if (!navigator.userAgent.match(/safari/i) || localStorage == null) {
          // safari || android webview
          parent.postMessage({
            scrollY: (elmnt.getBoundingClientRect().top +  this.tabsService.getTopHeight())
          }, '*');
        } else {
          // ios safari || android tarayıcı
          parent.postMessage({
            scrollY: (elmnt.getBoundingClientRect().top + this.tabsService.getTopHeight())
          }, '*');
        }
      } else {
        parent.postMessage({
          scrollY: (elmnt.getBoundingClientRect().top + this.tabsService.getTopHeight())
        }, '*');
      }
    }

    const zerothValues = this.formDataService.getZerothTabData();
    if (this.cashbackEnabled && zerothValues && zerothValues.paymentMethod === 'cash') {
      this.isShownIBAN = true;
    }
  }

  ngAfterViewInit() {

  }


  getQuestions(categoryId: number) {
    this.selecBoxService.getQuestions(categoryId).toPromise().then(
      (res) => {
        if (res && res.length > 0) {
          this.serviceError = false;
          this.deleteServiceErrors();

          res.forEach(question => {
            if (question.questionType === 3) {
              question.dropdownAnswerItems = this.getDropdownItems(question.dropdownAnswers);
            }
          });

          this.questions = this.defaultQuestions = res;
          this.questions = this.toConvertValidRows(res);
          if (this.formDataService.getSecondTab()) {
            this.oldAnswers = this.formDataService.getSecondTab().answers;
            this.selectedQuestion();
          }
          this.productQuestionsForm = this.toFormGroup(this.questions);
          this.initialized = true;
          if (Object.keys(this.productQuestionsForm.controls).length === 0 && this.productQuestionsForm.controls.constructor === Object) {
            this.validLength = true;
          }
        } else {
          this.serviceError = true;
          this.isValid = false;
          if (res.errorMessages.length > 0) {
            res.errorMessages.forEach(err => {
              this.checkErrorExist(err, this.errorTexts);
              this.checkErrorExist(err, this.serviceErrors);
            });
          }
          if (!res) {
            this.isValid = false;
            this.checkErrorExist('Servisten cevap alınamadı.', this.serviceErrors);
          }
        }
      }

    ).catch(error => {
      this.serviceError = true;
      this.serviceErrors.forEach(err => {
        this.checkErrorExist(err, this.serviceErrors);
      });
      error.errorMessages.forEach(err => {
        this.checkErrorExist(err, this.errorTexts);
      });
    });
  }

  toConvertValidRows(questions): any {
    const convertedRows = [];
    let i = 0;
    while (i < questions.length) {
      const newArray = [];
      if (questions[i + 1]) {
        newArray.push(questions[i], questions[i + 1]);
      } else {
        newArray.push(questions[i]);
      }
      convertedRows.push(newArray);
      i += 2;
    }
    return convertedRows;
  }

  toFormGroup(questions) {
    const group: any = {};
    questions.forEach((questionList) => {
      questionList.forEach((question) => {
        let answer;
        if (this.oldAnswers) {
          answer = _.find(this.oldAnswers, function (ans) { return ans.questionId == question.id; });
        }
        if (question.questionType === 0 || question.questionType === 1) {
          const hasAnswer = (answer && (answer.textAnswer || answer.yesNoAnswer));
          const ans = (hasAnswer) ? (answer.textAnswer) ? answer.textAnswer : answer.yesNoAnswer : '';
          group[question.id] = this.isMandatory(question.isMandatory, ans, false);
        } else if (question.questionType === 2) {
          if (answer) {
            setTimeout(() => {
              this.charCount = this.charCount - answer.textAnswer.length;
            });
          }
          const hasAnswer = (answer && answer.textAnswer);
          group[question.id] = this.isMandatory(question.isMandatory, (hasAnswer) ? answer.textAnswer : '', true);
        } else if (question.questionType === 3) {
          const hasAnswer = (answer && answer.dropdownAnswer);
          group[question.id] = this.isMandatory(question.isMandatory, (hasAnswer) ? answer.dropdownAnswer : '', false);
        }
      });
    });
    return new FormGroup(group);
  }

  isMandatory(isMand: boolean, answer, isTextArea: boolean) {
    if (isMand && !isTextArea) {
      return new FormControl((answer) ? answer : '', Validators.required);
    } else if (!isMand && !isTextArea) {
      return new FormControl((answer) ? answer : '');
    } else if (isMand && isTextArea) {
      return new FormControl((answer) ? answer : '', [Validators.maxLength(2000), Validators.required]);
    } else if (!isMand && isTextArea) {
      return new FormControl((answer) ? answer : '', Validators.maxLength(2000));
    }
  }

  deleteServiceErrors() {
    const hasServiceError = (this.serviceErrors.length > 0);
    if (hasServiceError) {
      this.serviceErrors.forEach(sErr => {
        this.errorTexts.forEach(err => {
          if (err == sErr) {
            this.errorTexts = _.without(this.errorTexts, err);
          }
        });
      });
    }
  }

  selectedQuestion() {
    this.newAnswers = this.createAnswers();
    this.proposal.answers = this.newAnswers;
    this.proposal.productId = this.tabsService.selectedProductId;
    this.proposal.categoryId = this.tabsService.selectedCategoryId;
    this.proposal.isCashback = this.cashbackSelected;
    this.formDataService.setSecondTab(this.proposal);
    this.getNewPrice(this.proposal);
  }

  countChar(text: string) {
    if (text) {
      this.charCount = 2000 - text.length;
    } else {
      this.charCount = 2000;
    }
  }

  createAnswers(): Answer[] {
    const result: Answer[] = [];
    Object.keys(this.productQuestionsForm.controls).forEach((key) => {
      const questionType = this.getQuestionType(key);

      result.push(
        {
          yesNoAnswer: (questionType == 0) ? this.productQuestionsForm.controls[key].value : '',
          textAnswer: (questionType == 1 || questionType == 2) ? this.productQuestionsForm.controls[key].value : '',
          dropdownAnswer: (questionType == 3) ? this.productQuestionsForm.controls[key].value : '',
          questionId: parseInt(key),
        }
      );
    });
    return result;
  }

  getDropdownItems(items) {
    return items.split(',').map(item => ({
      value: item,
      label: item,
    }));
  }

  getNewPrice(proposal: Proposal) {
    this.selecBoxService.getMerchantInfo(proposal).subscribe(
      (res: PriceResponse) => {
        if (res && res.success) {
          this.serviceError = false;
          this.deleteServiceErrors();
          this.tabsService.setMerchantInfo(res.data);
        } else {
          this.serviceError = true;
          this.isValid = false;
          this.tabsService.setPrice(0);
          if (res.errorMessages.length > 0) {
            res.errorMessages.forEach(err => {
              this.checkErrorExist(err, this.errorTexts);
              this.checkErrorExist(err, this.serviceErrors);
            });
          }
          if (!res) {
            this.serviceError = true;
            this.isValid = false;
            this.checkErrorExist('Servisten cevap alınamadı.', this.serviceErrors);
          }
        }
      },
      error => {
        this.serviceError = true;
        error.errorMessages.forEach(err => {
          this.checkErrorExist(err, this.errorTexts);
          this.checkErrorExist(err, this.serviceErrors);
        });
      }
    );
  }

  getQuestionType(key): number {
    let result;
    this.defaultQuestions.forEach((question: any) => {
      if (question.id == key) {
        result = question.questionType;
      }
    });
    return result;
  }

  formSubmit() {
    if (this.productQuestionsForm.valid) {
      this.errorTexts.forEach(err => {
        if (err === this.formMandatoryError) {
          this.errorTexts = _.without(this.errorTexts, err);
        }
      });
    }
    if (this.productQuestionsForm.valid) {
      this.selectedQuestion();
      this.selecBoxService.getMerchantInfo(this.proposal).subscribe(
        (res: PriceResponse) => {
          if (res && res.success) {
            this.serviceError = false;
            this.deleteServiceErrors();
            this.tabsService.setMerchantInfo(res.data);
            this.errorTexts = [];
            this.isValid = true;
            this.formDataService.setSecondTab(this.proposal);
            this.navBarService.setSelectedTab(this.tabSelected + 1);

            if ((!this.isAuth || !this.shopperId) && !this.isAuthWarning) {
              storageFactory(localStorage).setItem('formData', JSON.stringify({
                zeroth: this.formDataService.getZerothTabData(),
                first: this.formDataService.getFirstTabData(),
                second: this.formDataService.getSecondTab(),
                sidebar: {
                  price: this.tabsService.getPrice(),
                  label: this.tabsService.getLabel(),
                  imageUrl: this.tabsService.getImageUrl(),
                },
              }));
              storageFactory(localStorage).setItem('redirectedCategoryId', JSON.stringify(this.tabsService.getSelectedCategoryId()));
              parent.postMessage({event_id: 'buybackLogin'}, '*');
              return false;
            }
            this.sendDavinciEvent('sonrakiAdım');
            this.router.navigate(['/iletisim-bilgileri']);
          } else {
            this.serviceError = true;
            this.isValid = false;
            this.tabsService.setPrice(0);
            if (res.errorMessages.length > 0) {
              res.errorMessages.forEach(err => {
                this.checkErrorExist(err, this.errorTexts);
                this.checkErrorExist(err, this.serviceErrors);
              });
            }
            if (!res) {
              this.serviceError = true;
              this.isValid = false;
              this.checkErrorExist('Servisten cevap alınamadı', this.serviceErrors);
            }
          }
        },
        error => {
          this.serviceError = true;
          error.errorMessages.forEach(err => {
            this.checkErrorExist(err, this.errorTexts);
            this.checkErrorExist(err, this.serviceErrors);
          });
        }
      );
    } else {
      this.isValid = false;
      this.checkErrorExist(this.formMandatoryError, this.errorTexts);
      this.validateAllFormFields(this.productQuestionsForm);
    }

  }

  checkErrorExist(errorText: string, errorList: string[]) {
    if (!_.contains(errorList, errorText)) {
      errorList.push(errorText);
    }
  }

  prevStep() {
    this.navBarService.setSelectedTab(this.tabSelected - 1);
    this.sendDavinciEvent('öncekiAdım');
    this.router.navigate(['/model-secimi']);
  }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  sendDavinciEvent(buttonName) {
    try {
      hbusApiClient.sendEventRequest('DeviceInformation_Proposal', {
        page_type: 'static',
        page_value: 'eskiyi-getir-yeniyi-gotur',
        stepNo: 3,
        stepName: 'cihazDurumu',
        paymentOptions: this.cashbackSelected ? 'cash' : 'coupon',
        brand: this.brandName || '',
        model: this.modelName || '',
        proposedAmount: this.tabsService.getPrice() ?
          `${(this.tabsService.getPrice()).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`
          : '',
        buyBackCategory: this.categoryName || '',
        clickButtonInfo: buttonName,
      });
    } catch (e) {
      console.error('error send event', e.message);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/tabs/second-tab/second-tab.component.ts